<template>
  <div id="changeLanguage" @click="changeLanguage()">
    <span>{{$t('language.name')}}</span>
  </div>
</template>
<script>
export default {
  name: "changeLanguage",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale=='zh'?this.$i18n.locale='en':this.$i18n.locale='zh'   //设置中英文模式
      localStorage.setItem('languageSet',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
    }
  }
};
</script>
<style scoped>
#changeLanguage {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}
#changeLanguage > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/changeLanguage.vue